import {inject, Injectable} from '@angular/core';
import {Observable, timer} from 'rxjs';
import {exhaustMap, last, take, takeWhile} from 'rxjs/operators';
import {PaymentPollingStatus} from '@features/payment/domain/model/payment.model';
import {BatchPaymentsGateway} from '@features/payment/infrastructure/gateways/batch-payments.gateway';

@Injectable({providedIn: 'root'})
export class PaymentPollingEngine {
  private readonly gateway = inject(BatchPaymentsGateway);

  private readonly POLLING_ATTEMPTS = 30;
  private readonly POLLING_INTERVAL_MS = 1000;

  poll(transactionId: string, stopCondition?: (status: PaymentPollingStatus) => boolean): Observable<PaymentPollingStatus> {
    const isTerminal = stopCondition ?? ((status): boolean => status !== PaymentPollingStatus.PROCESSING);

    return timer(0, this.POLLING_INTERVAL_MS).pipe(
      take(this.POLLING_ATTEMPTS),
      exhaustMap(() => this.gateway.getStatus(transactionId)),
      takeWhile((status) => !isTerminal(status), true),
      last()
    );
  }
}
